import React, {useEffect, useState} from 'react';
import {User} from "types/User";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props = {
    audienceMember: User | null
    show: boolean
    onDelete?: (audienceMember: User) => any
    onDeleteFail?: (audienceMember: User, error: unknown) => any
    onCancel?: () => any
}

function DeleteAudienceMember(props: Props) {
    const {audienceMember, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(audienceMember?.name || 'this audience member');
    const {mutateAsync: deleteAudienceMember} = useMutation(ngage.users.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(audienceMember) setName(audienceMember.name)
    }, [audienceMember]);

    async function handleDeleteAudienceMember() {
        if (audienceMember) {
            try {
                await deleteAudienceMember(audienceMember.id)
                await invalidate('audienceMembers.all')

                notify("success", "Audience Member Deleted", `${audienceMember.name} has been permanently removed`)
                if (onDelete) onDelete(audienceMember)
            } catch (error) {
                notify("error", "Audience Member Not Deleted", `${audienceMember.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(audienceMember, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Audience Member"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteAudienceMember}
            onCancel={handleCancel}
        />
    );
}

export default DeleteAudienceMember;